import { useCallback, useRef } from 'react';

import apiActions from '../../../actions/apiActions';
import calendarActions from '../../../actions/calendarActions';

export default function useLinkEdit({ records, catalogId, sceneId, linkField, linkDirection }) {
  const pending = useRef(new Set());

  return useCallback(
    ({ source, target, type }, remove = false) => {
      if (!linkField || type !== 'e2s' || source === target) return;
      const [ownerId, relatedId] = linkDirection === 'successors' ? [source, target] : [target, source];
      const owner = records?.find((record) => record.get('id') === ownerId);
      const related = records?.find((record) => record.get('id') === relatedId);
      if (!owner || !related || pending.current.has(ownerId)) return;

      const fieldId = linkField.get('id');
      const previous = owner.getIn(['values', fieldId])?.toJS() || [];
      const matches = (item) =>
        String(item.catalogId) === String(catalogId) && String(item.recordId) === String(relatedId);
      if (!remove && previous.some(matches)) return;
      if (!remove && !linkField.getIn(['config', 'multiselect']) && previous.length) return;

      const next = remove
        ? previous.filter((item) => !matches(item))
        : [...previous, { catalogId, recordId: relatedId, recordTitle: related.get('title') }];
      const values = { [fieldId]: next };
      pending.current.add(ownerId);
      calendarActions.updateRecordBeforeMakeRequest({ recordId: ownerId }, values, sceneId);
      apiActions
        .updateRecord({ catalogId, recordId: ownerId }, { values }, { sceneId })
        .catch(() =>
          calendarActions.updateRecordBeforeMakeRequest({ recordId: ownerId }, { [fieldId]: previous }, sceneId),
        )
        .finally(() => pending.current.delete(ownerId));
    },
    [records, catalogId, sceneId, linkField, linkDirection],
  );
}
